/**
 * Optional store URLs for mobile app promo CTAs (only shown when set).
 * @see apps/plaatplan-web/docs/10-web-feature-flags.md
 */

function readEnv(name) {
  const value = process.env[name];
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export function getMobileAppStoreLinks() {
  return {
    appStore: readEnv("REACT_APP_MOBILE_APP_STORE_URL"),
    playStore: readEnv("REACT_APP_MOBILE_PLAY_STORE_URL"),
  };
}

export function hasMobileAppStoreLinks() {
  const { appStore, playStore } = getMobileAppStoreLinks();
  return Boolean(appStore || playStore);
}
